import { NgModule,CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReactionsSummaryComponent} from './reactions-summary.component';



@NgModule({
  declarations: [
    ReactionsSummaryComponent
  ],
  imports: [
    CommonModule
  ],
  exports:[ReactionsSummaryComponent],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class ReactionsSummaryModule { }
